import { Link } from "react-router-dom";
import influencerImage1 from "../assets/images/influ8.png";

const SingleInfluencerCircle = ({ padding, margin }) => {
  const classes = Object.values({
    initialClasses: "single-influencer group inline-block",
    padding: padding ? padding : "px-5 pb-12 pt-0",
    margin: margin ? margin : "m-0",
  }).join(" ");
  return (
    <li className={classes}>
      <Link to={""}>
        <div className="inline-block text-center">
          <div className="image  rounded-full overflow-hidden inline-block h-32 w-32 transition-all duration-500 group-hover:scale-110 mb-5">
            <img src={influencerImage1} alt="" className="" />
          </div>
          <div className="title text-sm text-black">
            <h5>Sevgi Altun</h5>
          </div>
          <div className="followers-count text-[#e66553]">
            <span className="">22k takipici</span>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default SingleInfluencerCircle;
